<template>
    <section class="sessao-questionnaire">
        <div class="row">
            <div class="col-xs-12">
                <h3><icon name="list-alt"></icon> Avaliação de riscos</h3>
            </div>
        </div>
        <div class="row m-0">
            <div class="col-xs-12">
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                         <div class="form-group">
                            <div class='input-group'>
                                <label class="switch">
                                    <input type="checkbox" id="data.residence.storage_material" :checked="storage_material" v-model="questionnaire.storage_material">
                                    <span class="slider round"></span>
                                    <span class="absolute-no">Local utilizado exclusivamente para depósito de materiais</span>
                                </label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.storage_material')">{{ errors.first('data.residence.storage_material') }}</div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-md-6">
                         <div class="form-group">
                            <div class='input-group'>
                                <label class="switch">
                                    <input type="checkbox" id="data.residence.boxes_electronics'" :checked="boxes_electronics" v-model="questionnaire.boxes_electronics">
                                    <span class="slider round"></span>
                                    <span class="absolute-no">Imóvel possui caixas eletrônicos em suas dependências</span>
                                </label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.boxes_electronics')">{{ errors.first('data.residence.boxes_electronics') }}</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-md-6">
                         <div class="form-group">
                            <div class='input-group'>
                                <label class="switch">
                                    <input type="checkbox" id="data.residence.wasted_currency" :checked="wasted_currency" v-model="questionnaire.wasted_currency">
                                    <span class="slider round"></span>
                                    <span class="absolute-no">Imóvel faz divisa com terreno baldio</span>
                                </label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.wasted_currency')">{{ errors.first('data.residence.wasted_currency') }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                         <div class="form-group">
                            <div class='input-group'>
                                <label class="switch">
                                    <input type="checkbox" id="data.residence.isopainel" :checked="isopainel" v-model="questionnaire.isopainel">
                                    <span class="slider round"></span>
                                    <span class="absolute-no">Imóvel possui Isopainel em sua construção</span>
                                </label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.isopainel')">{{ errors.first('data.residence.isopainel') }}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                         <div class="form-group">
                            <div class='input-group'>
                                <label class="switch">
                                    <input type="checkbox" id="data.residence.historical_heritage" :checked="historical_heritage" v-model="questionnaire.historical_heritage">
                                    <span class="slider round"></span>
                                    <span class="absolute-no">Imóvel tombado pelo patrimônio histórico</span>
                                </label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.historical_heritage')">{{ errors.first('data.residence.historical_heritage') }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                         <div class="form-group">
                            <div class='input-group'>
                                <label class="switch">
                                    <input type="checkbox" id="data.residence.construction_renovation" :checked="construction_renovation"  v-model="questionnaire.construction_renovation">
                                    <span class="slider round"></span>
                                    <span class="absolute-no">Imóvel em construção ou reforma</span>
                                </label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.construction_renovation')">{{ errors.first('data.residence.construction_renovation') }}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                         <div class="form-group">
                            <div class='input-group'>
                                <label class="switch">
                                    <input type="checkbox" id="metal_structure" :checked="metal_structure" v-model="questionnaire.metal_structure">
                                    <span class="slider round"></span>
                                    <span class="absolute-no">Imóvel possui telhado e/ou estrutura feita de metal</span>
                                </label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.metal_structure')">{{ errors.first('data.residence.metal_structure') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style>
    .m-0
    {
        margin: 0 0 0 0;
    }
</style>
<script>
    import FormHelp from 'shared/modules/Help/FormHelp.vue'

    export default {
        components: {
            FormHelp
        },
        props: {questionnaire:Object},
        data(){
            return {
            }
        },
        computed: {
            quotation(){
                return this.$store.getters['quotation']
            }
        },
        watch: {
            quotation(quotation){
                if( ! quotation.data.data.questionnaire )
                    return
                this.questionnaire.storage_material          = quotation.data.data.questionnaire.storage_material || false
                this.questionnaire.wasted_currency           = quotation.data.data.questionnaire.wasted_currency || false
                this.questionnaire.historical_heritage       = quotation.data.data.questionnaire.historical_heritage || false
                this.questionnaire.metal_structure           = quotation.data.data.questionnaire.metal_structure || false
                this.questionnaire.boxes_electronics         = quotation.data.data.questionnaire.boxes_electronics || false
                this.questionnaire.isopainel                 = quotation.data.data.questionnaire.isopainel || false
                this.questionnaire.construction_renovation   = quotation.data.data.questionnaire.construction_renovation || false
            },
        }
    }
</script>



// WEBPACK FOOTER //
// FormPartialQuestionnaire.vue?73058a80